import Box from '@mui/material/Box'
import type { SxProps, Theme } from '@mui/material/styles'

// The brand pack's header lockup (wordmark) or its JP mark, served from
// /brand/ by each app's public dir. The files are white on `onDark`
// surfaces (the navy app bar and drawer, in both modes) and Pilot Blue on
// light ones, so the caller says which surface it sits on instead of
// guessing from the theme.
export function BrandLogo({
  variant = 'full',
  onDark = false,
  height = 32,
  sx,
}: {
  variant?: 'full' | 'mark'
  onDark?: boolean
  height?: number
  sx?: SxProps<Theme>
}) {
  const file = `${variant === 'full' ? 'header-logo' : 'header-mark'}-${onDark ? 'dark' : 'light'}.svg`
  return (
    <Box
      component="img"
      src={`${import.meta.env?.BASE_URL ?? '/'}brand/${file}`}
      alt="Jukolan Pilotit r.y."
      sx={{ height, width: 'auto', display: 'block', ...sx }}
    />
  )
}
